import { MODO_IMPORTE } from "./static"

const enteros = new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 })

const decimales = new Intl.NumberFormat("es-MX", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const numero = valor => enteros.format(Number(valor) || 0)

export const moneda = valor => `$ ${decimales.format(Number(valor) || 0)}`

export const piezas = valor => `${enteros.format(Number(valor) || 0)} pzas`

/** «12.5 %», o un guion cuando no hay nada que medir. */
export const porcentaje = valor =>
  valor === null || valor === undefined
    ? "—"
    : `${decimales.format(Number(valor))} %`

/**
 * Etiqueta corta para los ejes de las gráficas: los importes completos
 * («$ 2,184,300.00») desbordan el eje vertical.
 */
export const corto = (valor, modo = MODO_IMPORTE) => {
  const v = Number(valor) || 0
  const signo = v < 0 ? "-" : ""
  const abs = Math.abs(v)
  const prefijo = modo === MODO_IMPORTE ? "$" : ""

  if (abs >= 1e6) return `${signo}${prefijo}${(abs / 1e6).toFixed(1)}M`
  if (abs >= 1e3) return `${signo}${prefijo}${Math.round(abs / 1e3)}K`
  return `${signo}${prefijo}${Math.round(abs)}`
}

/** Suma una serie del backend, que llega como array de números o de cadenas. */
export const suma = serie =>
  (serie || []).reduce((total, valor) => total + (Number(valor) || 0), 0)

/**
 * Variación porcentual contra el año anterior. Sin base con la que comparar no
 * se inventa un 100 %: se devuelve null y la píldora no se pinta.
 */
export const variacion = (actual, anterior) => {
  const base = Number(anterior) || 0
  if (base <= 0) return null
  return ((Number(actual) - base) / base) * 100
}
